import React, { useEffect, useState } from 'react';
import {
  ProcessedExceptionContainer,
  ProcessedExceptionWrapper,
  ProcessedExceptionHeader,
  ProcessedExceptionHeaderTitle,
  ProcessedExceptionHeaderArea,
  ProcessedExceptionContent,
  ProcessedExceptionFilterContainer,
  ProcessedExceptionFilterColumn,
  ProcessedExceptionFilterInputSearch,
  ProcessedExceptionFilterShowContent,
  ProcessedExceptionFilterShowOptionSpan,
  ProcessedExceptionFilterShowOptionContent,
  ProcessedExceptionFilterShowOptionSelectOption,
  ProcessedExceptionFilterShowOptionSelect,
  ProcessedExceptionFilterShowOptionSelected,
  ProcessedExceptionListContent,
  ProcessedExceptionEmptyStateContainer,
  ProcessedExceptionEmptyStateParagraph
} from './styles';
import { P, H4 } from '../../components/Typography/styles';
import colors from '../../assets/styles/colors';
import Copyright from '../../components/Copyright';
import GridColCard from '../../components/GridColCard';
import { BsSearch, BsChevronDown } from 'react-icons/bs';
import { getExceptionsByAsesor } from '../../services/exceptions';
import { distinctByExceptionStatus } from '../../helpers/distinct';
import { exceptionStatus } from '../../helpers/enum';
import Loader from '../../components/Loader';
import emptyState from '../../assets/images/empty.svg';

const ProcessedExceptionsPage = () => {
  const session = JSON.parse(localStorage.getItem('@EC-session'));
  const [exceptions, setExceptions] = useState([]);
  const [exceptionsCompleteList, setExceptionsCompleteList] = useState([]);
  const [showBy, setShowBy] = useState({ nombre: 'Todos'});
  const [showByExpand, setShowByExpand] = useState(false);
  const [search, setSearch] = useState('');
  const [statusDescription, setStatusDescription] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  async function initializeStateComponent() {
    try {
      const exceptions = await getExceptionsByAsesor(session.idAsesor);

      exceptions.data.forEach(item => {
        item.cliente.nombre = item.cliente.nombres
        item.estado = item.estadoSolicitud
        item.fecha = item.estado.fecha
      })
      
      let newStatus = distinctByExceptionStatus(exceptions.data);
      newStatus = newStatus.map(status => {
        return {
          label: status
        }
      });

      setExceptions(exceptions.data);
      setExceptionsCompleteList(exceptions.data);
      setStatusDescription(newStatus);
      setIsLoading(false);
    } catch (error) {
      
    }
  }

  useEffect(() => {
    let exceptionsArr = exceptionsCompleteList;

    if (search.length) {
      exceptionsArr = exceptionsArr.filter(item => item.cliente.identificacion.indexOf(search) > -1 || item.cliente.nombres.toLowerCase().indexOf(search.toLocaleLowerCase()) > -1);
    }

    if (showBy.nombre !== 'Todos') {
      exceptionsArr = exceptionsArr.filter(item => exceptionStatus[item.solicitudExcepciones.estado].nombre === showBy.nombre);
    }

    setExceptions(exceptionsArr)
    setShowByExpand(false);
  }, [showBy, search]);

  useEffect(() => {
    initializeStateComponent();
  }, [])

  return (
    <ProcessedExceptionContainer id="processed-exceptions-page">
      <ProcessedExceptionWrapper>
        <ProcessedExceptionHeader>
          <ProcessedExceptionHeaderTitle>Mis Solicituds</ProcessedExceptionHeaderTitle>
          <ProcessedExceptionHeaderArea>
            <H4 color={colors.textPrimary}>Excepciones tramitadas</H4>
            <P bold color={colors.textPrimary}></P>
          </ProcessedExceptionHeaderArea>
        </ProcessedExceptionHeader>
        <ProcessedExceptionContent>
          <ProcessedExceptionFilterContainer id="filter">
            <ProcessedExceptionFilterColumn>
              <BsSearch size={18} color={colors.bgSecondary} id="search-icon" />
              <ProcessedExceptionFilterInputSearch placeholder="Nombre, apellido, CC o CE" onChange={e => setSearch(e.target.value)} id="search-field" />
            </ProcessedExceptionFilterColumn>
            <ProcessedExceptionFilterColumn>
              <ProcessedExceptionFilterShowContent>
                <ProcessedExceptionFilterShowOptionSpan>Visualizar</ProcessedExceptionFilterShowOptionSpan>
                <ProcessedExceptionFilterShowOptionSelect onClick={() => setShowByExpand(!showByExpand)} tabIndex={0} id="show-by">
                  <ProcessedExceptionFilterShowOptionSelected>{showBy.nombre}</ProcessedExceptionFilterShowOptionSelected>
                  <BsChevronDown id="chevron-downicon" />
                </ProcessedExceptionFilterShowOptionSelect>
                <ProcessedExceptionFilterShowOptionContent open={showByExpand} id="select-category">
                    <ProcessedExceptionFilterShowOptionSelectOption active={showBy.nombre === 'Todos' && true} onClick={() => setShowBy({ nombre: 'Todos'})}>Todos</ProcessedExceptionFilterShowOptionSelectOption>
                    {statusDescription.map((item, key) => item && (
                      <ProcessedExceptionFilterShowOptionSelectOption
                        id={`category${key}`}
                        key={key}
                        active={item.label === showBy.nombre && true}
                        onClick={() => setShowBy(exceptionStatus[item.label])}>
                        {exceptionStatus[item.label].nombre}
                      </ProcessedExceptionFilterShowOptionSelectOption>)
                    )}
                  </ProcessedExceptionFilterShowOptionContent>
              </ProcessedExceptionFilterShowContent>
            </ProcessedExceptionFilterColumn>
          </ProcessedExceptionFilterContainer>

          {!exceptions.length ? (
            <ProcessedExceptionEmptyStateContainer>
              <img src={emptyState} alt="Empty state" />
              <ProcessedExceptionEmptyStateParagraph>
              No hay información para visualizar
              </ProcessedExceptionEmptyStateParagraph>
            </ProcessedExceptionEmptyStateContainer>
          ) : ''}

          <ProcessedExceptionListContent>
            {exceptions.map((item, key) => (
              <GridColCard key={key} item={item} exception={item.solicitudExcepciones.estado} canalEstado="digicredito"/>
            ))}
          </ProcessedExceptionListContent>

        </ProcessedExceptionContent>
      </ProcessedExceptionWrapper>
      {isLoading && <Loader />}
      <Copyright />
    </ProcessedExceptionContainer>
  )
}

export default ProcessedExceptionsPage;
